@if (formGroup) {
	<form [formGroup]="formGroup">
		<div class="form-row d-flex justify-content-center justify-content-lg-end">
			<div class="col-auto"><p class="font-size-085 mb-1">Dashboard:</p></div>
			<div class="col-auto form-element-container font-size-085 pb-0">
				<div class="custom-control custom-switch switch-lever">
					<input type="checkbox" id="layoutSwitchLever" class="custom-control-input" formControlName="value" />
					<label for="layoutSwitchLever" class="custom-control-label"></label>
					<span class="custom-lever-label-left">{{ featureFlagDefault.offName }}</span>
					<span class="custom-lever-label-right mr-xl-3">{{ featureFlagDefault.onName }}</span>
				</div>
			</div>
		</div>
	</form>
}
